import { render, staticRenderFns } from "./NotificationsPrompt.vue?vue&type=template&id=7304154a"
import script from "./NotificationsPrompt.vue?vue&type=script&lang=js"
export * from "./NotificationsPrompt.vue?vue&type=script&lang=js"
import style0 from "./NotificationsPrompt.vue?vue&type=style&index=0&id=7304154a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports